export default {"src":"/_next/static/media/HeaderBackground.f935d771.svg","height":479,"width":1684,"blurWidth":0,"blurHeight":0};